import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BASE_URL } from "../../../api/EndPoints";
import { useNavigate } from "react-router-dom";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import _ from "lodash";
import "./CartVariant.css";
import silkimg from "../../../assets/silk.jpg";

const CartVariant = ({
  items,
  ribData,
  handleIndividualChange,
  handleEdit,
  handleRemoveItem,
  activeIndex,
  sampleSelected,
  wholesaleSelected,
  swatchSelected,
  price,
  uom,
  metre,
}) => {
  const navigate = useNavigate();
  console.log(items, "itemmmmmnk ")
  if (items.combo) {
    return (
      <div className="flex g-8 cart-item-padding p-b-8">

        <div className="compo-cart-product-layout">
          <div className="items-center-prev-new" >
            <span style={{ backgroundColor: items?.combo?.abandoned === true ? "#e57373" : "#388e3c", display: "flex", borderRadius: "14px", justifyContent: "center", alignItems: "center", width: "fit-content", padding: "2px 8px" }}>{items?.combo?.abandoned === true ? "Previous" : "New"}</span>
          </div>
          {items.outOfStock && !items.backOrder && (

            <div
              style={{
                color: "#b82e2e",
                backgroundColor: "#fef0f0",
                borderRadius: "8px",
                padding: "12px 16px",
                marginBottom: "10px",
              }}
            >
              <FontAwesomeIcon
                icon={faCircleExclamation}
                style={{ paddingRight: "0.5rem", paddingLeft: "0.5rem" }}
              />
              Checkout unavailable product status
              {/* {item.quantity > item.availableQuantity &&
            activeIndex === "wholesale" && (
              <>Total Available Quantity is {item.availableQuantity} kg</>
            )}
           {item.quantity > item.totalStockQuantity &&
            activeIndex === "sample" && (
              <>Total Available Quantity is {item.totalStockQuantity} kg</>
            )} */}
            </div>
          )}
          <div
            className="adaptive-layout boundary-width-768 flex-fill"
            style={{ gap: "16px" }}
          ></div>
          {items.variants.length > 0 ? (
            <>
              {_.map(items.variants, (variant, index) => (
                <>
                  <div className="flex g-8 cart-item-padding p-b-8">
                    <div className="cart-product-layout">
                      <div
                        className="adaptive-layout boundary-width-768 flex-fill"
                        style={{ gap: "16px" }}
                      >
                        <div
                          className="adaptive-layout boundary-width-768 flex-fill g-40"
                          style={{ gap: "10px" }}
                        >

                          <div className="flex-row items-start " >

                            <div className="wrapper-product-info" style={{ display: "flex", paddingBottom: "8px" }}>
                              <div className="img-name-head">
                                <div className="image-container flex-wrap">
                                  <div className="product-image-thumbnail center overlay">
                                    <img
                                      className="app-img cover"
                                      src={`${BASE_URL}${variant?.image?.replace(
                                        "/api",
                                        ""
                                      )}?time=${Date?.now()}`}
                                      alt="ultronOn - No. 1 Wholesale fabric platform for Fashion Brands"
                                      loading="lazy"
                                    />
                                  </div>
                                </div>
                                <div className="text-nowrappp" >
                                  <div className="lcn-container" >
                                    <div className="pd-code">
                                      <span
                                        className="clickable-area"
                                        onClick={() => {
                                          if (items.combo.published === "true") {
                                            navigate(`${items.combo.pimUrl}`);
                                          }
                                        }}
                                      >
                                        #{index + 1} {variant.name}
                                      </span>
                                    </div>
                                    {items.combo.published === "false" && (
                                      <p style={{ color: "red" }}>
                                        (Product unavailable)
                                      </p>
                                    )}
                                    {/* 
                                    <div className="adaptive-label-color-number">
                                      <span style={{ fontSize: "14px" }}>
                                        {
                                          variant.variants.filter(
                                            (item) => item.type === "Colour"
                                          )[0].value
                                        }
                                      </span>
                                    </div> */}
                                    {items?.combo?.cartType !== "SAMPLE" && items?.combo?.cartType !== "SWATCH" && (<div>
                                      No. of Rolls :{" "}
                                      {(items?.combo?.quantity /
                                        items?.combo?.kgPerRoll).toFixed(2)}
                                    </div>)}

                                    <div>
                                      {uom[variant?.variantSku]}/Roll :{" "}
                                      {(items?.combo?.kgPerRoll.toFixed(2))}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="flex-row-int-price">{items.combo.quantity.toFixed(2)}   {uom[variant?.variantSku]}</div>
                              <div className="flex-dtyy" >

                                <div className="price-gre-color">
                                  <div style={{ fontWeight: "bold" }}>
                                    &#8377;
                                    {(
                                      items.combo.quantity *
                                      items.combo.sellingPrice
                                    ).toFixed(2)}
                                  </div>
                                  <div className="cart-kg" style={{ justifyContent: "center" }} >
                                    &#8377;
                                    {(items?.combo.sellingPrice).toFixed(2)}/ {uom[variant?.variantSku]}
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                      {/*...........................................rib for combo .................. */}
                      {variant?.ribItem && (
                        <div className="flex g-4 cart-item-padding p-b-8">
                          <div className="cart-product-layout">
                            <div className="rib-data" >
                              <div
                                className="adaptive-layout boundary-width-728 flex-fill"
                              >
                                <div className="Rib-avai" style={{ fontWeight: "bold", color: "white", marginBottom: "10px" }}>RIB</div>

                                <div
                                  className="adaptive-layout boundary-width-768 flex-fill"

                                >
                                  <div className="flex-row items-start ">
                                    <div className="wrapper-product-info" style={{ display: "flex" }}>
                                      <div className="img-name-head">
                                        <div className="image-container flex-wrap">
                                          <div className="product-image-thumbnail center overlay">
                                            <img
                                              className="app-img cover"
                                              src={`${BASE_URL}${variant?.ribItem?.image?.replace(
                                                "/api",
                                                ""
                                              )}?time=${Date?.now()}`}
                                              alt="ultronOn - No. 1 Wholesale fabric platform for Fashion Brands"
                                              loading="lazy"
                                            />
                                          </div>
                                        </div>
                                        <div className="text-nowrappp" >
                                          <div className="lcn-container" >
                                            <div className="pd-code">
                                              <span
                                                className="clickable-area"
                                                onClick={() => {
                                                  if (items.combo.published === "true") {
                                                    navigate(`${items.combo.pimUrl}`);
                                                  }
                                                }}
                                              >
                                                #{index + 1} {variant?.ribItem?.variantName}

                                              </span>
                                            </div>
                                            {items.combo.published === "false" && (
                                              <p style={{ color: "red" }}>
                                                (Product unavailable)
                                              </p>
                                            )}
                                            {/* 
                                    <div className="adaptive-label-color-number">
                                      <span style={{ fontSize: "14px" }}>
                                        {
                                          variant.variants.filter(
                                            (item) => item.type === "Colour"
                                          )[0].value
                                        }
                                      </span>
                                    </div> */}

                                            <div>
                                              {uom[variant?.ribItem?.variantSku]}/Roll :{" "}
                                              {(variant?.ribItem?.kgPerRoll.toFixed(2))}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="flex-row-int-price">{variant?.ribItem?.quantity.toFixed(2)}   {uom[variant?.ribItem?.variantSku]}</div>
                                      <div className="flex-dtyy" >

                                        <div className="price-gre-color">
                                          <div style={{ fontWeight: "bold" }}>
                                            &#8377;
                                            {(
                                              variant?.ribItem?.quantity *
                                              variant?.ribItem?.sellingPrice
                                            ).toFixed(2)}
                                          </div>
                                          <div className="cart-kg" style={{ justifyContent: "center" }} >
                                            &#8377;
                                            {(variant?.ribItem?.sellingPrice).toFixed(2)}/ {uom[variant?.ribItem?.variantSku]}
                                          </div>
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                </div>
                              </div></div>
                          </div>
                        </div>)}
                      <br />
                    </div>
                  </div>
                </>
              ))}
            </>
          ) : (
            <>
              <p style={{ color: "red" }}>(Combo unavailable)</p>
            </>
          )}
        </div>
      </div>
    );
  }
  return items.map((item, index) =>
    <div className="cart-product selected" key={index} style={{ marginBottom: "10px" }}>
      {item?.cartType !== "SWATCH" ? (<div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
        {activeIndex !== "swatch" && (
          <input
            type="checkbox"
            className="app-checkbox flex-wrap"
            checked={(activeIndex === "sample"
              ? sampleSelected
              : activeIndex === "wholesale"
                ? wholesaleSelected
                : activeIndex === "swatch"
                  ? swatchSelected
                  : []
            )?.some((selectedItem) => selectedItem.id === item.id)}
            onChange={() => handleIndividualChange(item)}
            disabled={
              item.published === "false" ||
              (item.outOfStock && !item.backOrder) ||
              item?.comboVariants?.includes(item?.variantSku) || item?.combo && (item?.outOfStock)
            }
          />
        )}
        {console.log(item, "itemmmmmnk ")}
        <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
          <div className="items-center-prev-new" >

            <span style={{ backgroundColor: item?.abandoned === true ? "#e1a2a2" : "#b5da84", display: "flex", borderRadius: "14px", justifyContent: "center", alignItems: "center", width: "fit-content", padding: "2px 8px" }}>{item?.abandoned === true ? "Previous" : "New"}</span>
          </div>
          {item?.typeOfSupply === "OrderDriven" && <div className="items-center-prev-new" >  <span style={{ backgroundColor: item?.typeOfSupply === "VendorReadyStock" ? "#e793ea " : item?.typeOfSupply === "OrderDriven" ? "#e5bf73" : item?.typeOfSupply === "readyStock" ? "#5b8cbd " : "", display: "flex", borderRadius: "14px", justifyContent: "center", alignItems: "center", width: "fit-content", padding: "2px 8px" }}>{item?.typeOfSupply === "VendorReadyStock" ? "Vendor Stock" : item?.typeOfSupply === "OrderDriven" ? "Made To Order" : item?.typeOfSupply === "readyStock" ? "Ready Stock" : ""}</span></div>}</div>
      </div>) : (<div className="items-center-prev-new" >

        <span style={{ backgroundColor: item?.abandoned === true ? "#e57373" : "#b5da84", display: "flex", borderRadius: "14px", justifyContent: "center", alignItems: "center", width: "fit-content", padding: "2px 8px" }}>{item?.abandoned === true ? "Previous" : "New"}</span>
      </div>

      )}
      {item.quantity < (item.moqtypeSupply || 0) && (

        <div
          style={{
            color: "#b82e2e",
            backgroundColor: "#fef0f0",
            borderRadius: "8px",
            padding: "12px 16px",
            marginBottom: "10px",
          }}
        >
          <FontAwesomeIcon
            icon={faCircleExclamation}
            style={{ paddingRight: "0.5rem", paddingLeft: "0.5rem" }}
          />
          Note : Minimum qty is greater than or equal to {item.moqtypeSupply || 0}
          {/* {item.quantity > item.availableQuantity &&
            activeIndex === "wholesale" && (
              <>Total Available Quantity is {item.availableQuantity} kg</>
            )}
           {item.quantity > item.totalStockQuantity &&
            activeIndex === "sample" && (
              <>Total Available Quantity is {item.totalStockQuantity} kg</>
            )} */}
        </div>
      )}
      {item.outOfStock && !item.backOrder && (

        <div
          style={{
            color: "#b82e2e",
            backgroundColor: "#fef0f0",
            borderRadius: "8px",
            padding: "12px 16px",
            marginBottom: "10px",
          }}
        >
          <FontAwesomeIcon
            icon={faCircleExclamation}
            style={{ paddingRight: "0.5rem", paddingLeft: "0.5rem" }}
          />
          Checkout unavailable product status
          {/* {item.quantity > item.availableQuantity &&
            activeIndex === "wholesale" && (
              <>Total Available Quantity is {item.availableQuantity} kg</>
            )}
           {item.quantity > item.totalStockQuantity &&
            activeIndex === "sample" && (
              <>Total Available Quantity is {item.totalStockQuantity} kg</>
            )} */}
        </div>
      )}
      {item?.comboVariants?.includes(item?.variantSku) && item?.cartType != "SAMPLE" && (

        <div
          style={{
            color: "#b82e2e",
            backgroundColor: "#fef0f0",
            borderRadius: "8px",
            padding: "12px 16px",
            marginBottom: "10px",
          }}
        >
          <FontAwesomeIcon
            icon={faCircleExclamation}
            style={{ paddingRight: "0.5rem", paddingLeft: "0.5rem" }}
          />
          Checkout unavailable product since it a Combo
          {/* {item.quantity > item.availableQuantity &&
            activeIndex === "wholesale" && (
              <>Total Available Quantity is {item.availableQuantity} kg</>
            )}
           {item.quantity > item.totalStockQuantity &&
            activeIndex === "sample" && (
              <>Total Available Quantity is {item.totalStockQuantity} kg</>
            )} */}
        </div>
      )}

      <div className="flex g-8 cart-item-padding p-b-8">
        <div className="cart-product-layout">
          <div
            className="adaptive-layout boundary-width-768 flex-fill"
            style={{ gap: "16px" }}
          >
            <div
              className="adaptive-layout boundary-width-768 flex-fill"
            >
              <div className="flex-row items-start ">
                <div className="wrapper-product-info" style={{ display: "flex" }}>
                  <div className="img-name-head">
                    <div className="image-container flex-wrap">
                      <div className="product-image-thumbnail center overlay">
                        <img
                          className="app-img cover"
                          src={`${BASE_URL}${item?.image?.replace(
                            "/api",
                            ""
                          )}?time=${Date?.now()}`}
                          alt="ultronOn - No. 1 Wholesale fabric platform for Fashion Brands"
                          loading="lazy"
                        />
                      </div>
                    </div>
                    <div className="text-nowrappp" >
                      <div className="lcn-container" >
                        <div className="pd-code">
                          <span
                            className="clickable-area"
                            onClick={() => {
                              if (item?.published === "true") {
                                navigate(`${item?.pimUrl}`);
                              }
                            }}
                          >
                            #{index + 1} {item?.variantName}
                          </span>
                        </div>
                        {item?.published === "false" && (
                          <p style={{ color: "red" }}>
                            (Product unavailable)
                          </p>
                        )}

                        {item?.cartType !== "SAMPLE" && item?.cartType !== "SWATCH" && (<div>
                          No. of Rolls :{" "}
                          {(item?.quantity /
                            item?.kgPerRoll).toFixed(2)}
                        </div>)}

                        {item?.cartType === "SWATCH" && (<div>
                          Total Qty :{" "}
                          {(item?.quantity)}
                        </div>)}
                        {item?.cartType !== "SWATCH" && (<div>
                          {uom?.[item?.variantSku]} / Roll : {(item?.kgPerRoll || 0).toFixed(2)}
                        </div>)}
                      </div>
                    </div>
                  </div>
                  <div className="flex-row-int-price">{item?.quantity.toFixed(2)}   {uom[item?.variantSku]}{item?.cartType === "SWATCH" && "pcs"}</div>
                  <div className="flex-dtyy" >

                    <div className="price-gre-color">
                      <div style={{ fontWeight: "bold" }}>
                        {item?.cartType !== "SWATCH" && `₹`}

                        {(
                          item?.quantity *
                          ((item?.sellingPrice))
                        ).toFixed(2)}         {item?.cartType === "SWATCH" && `points`}
                      </div>
                      <div className="cart-kg" style={{ justifyContent: "center" }} >
                        {item?.cartType !== "SWATCH" && `₹`}
                        {(item?.sellingPrice).toFixed(2)} {item?.cartType === "SWATCH" && `points`}/ {uom[item?.variantSku]}{item?.cartType === "SWATCH" && "pcs"}
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* .........................................rib for wholesale.......................... */}
      {item?.ribItem && (
        <div className="flex g-4 cart-item-padding p-b-8">
          <div className="cart-product-layout">
            <div className="rib-data" >
              <div
                className="adaptive-layout boundary-width-728 flex-fill"
              >
                <div className="Rib-avai" style={{ fontWeight: "bold", color: "white", marginBottom: "10px" }}>RIB</div>
                <div className="adaptive-layout boundary-width-768 flex-fill"

                >
                  <div className="flex-row items-start ">
                    <div className="wrapper-product-info" style={{ display: "flex" }}>
                      <div className="img-name-head">
                        <div className="image-container flex-wrap">
                          <div className="product-image-thumbnail center overlay">
                            <img
                              className="app-img cover"
                              src={`${BASE_URL}${item?.ribItem?.image?.replace(
                                "/api",
                                ""
                              )}?time=${Date?.now()}`}
                              alt="ultronOn - No. 1 Wholesale fabric platform for Fashion Brands"
                              loading="lazy"
                            />
                          </div>
                        </div>
                        <div className="text-nowrappp" >
                          <div className="lcn-container" >
                            <div className="pd-code">
                              <span
                                className="clickable-area"
                                onClick={() => {
                                  if (item?.ribItem?.published === "true") {
                                    navigate(`${item?.ribItem?.pimUrl}`);
                                  }
                                }}
                              >
                                #{index + 1} {item?.ribItem?.variantName}
                              </span>
                            </div>
                            {item?.ribItem?.published === "false" && (
                              <p style={{ color: "red" }}>
                                (Product unavailable)
                              </p>
                            )}
                            <div>
                              {uom[item?.ribItem?.variantSku]}/Roll :{" "}
                              {(item?.ribItem?.kgPerRoll.toFixed(2))}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="flex-row-int-price">{item?.ribItem?.quantity.toFixed(2)}   {uom[item?.ribItem?.variantSku]}</div>
                      <div className="flex-dtyy" >

                        <div className="price-gre-color">
                          <div style={{ fontWeight: "bold" }}>
                            &#8377;
                            {(
                              item?.ribItem?.quantity *
                              (item?.ribItem?.sellingPrice)
                            ).toFixed(2)}
                          </div>
                          <div className="cart-kg" style={{ justifyContent: "center" }} >
                            &#8377;
                            {(item?.ribItem?.sellingPrice).toFixed(2)}/ {uom[item?.ribItem?.variantSku]}
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div></div>
          </div>
        </div>)}
      {/* ..................................................................... */}
      <div className="cart-item-functions cart-item-padding p-t-0">
        {activeIndex !== "swatch" && activeIndex !== "sample" && (
          <div className="cart-item-function" onClick={() => handleEdit(item)}>
            Edit
          </div>
        )}
        <div className="small-vr">|</div>
        <div
          className="cart-item-function"
          onClick={() => handleRemoveItem(item)}
        >
          Remove
        </div>
      </div>
    </div>
  );
};

export default CartVariant;
